import { FC } from "react"
import { useParams } from "react-router-dom"
import { UserbotPage } from "./userbotPage"
import { FinishedChainReport } from "../components"

export const FinishedChainReportPage: FC = () => {
  const { id } = useParams<{ id: string }>()
  return (
    <UserbotPage title="Завершённая цепочка">
      {id && <FinishedChainReport id={id} />}
    </UserbotPage>
  )
}
